export default {
  ProjectNumber: '项目编号',
  ClientName: '客户名称',
  LinkMan: '联系人',
  ContactNumber: '联系电话',
  ContactAddress: '联系地址',
  BillingAddress: '账单地址',
  CustomerAccount: '用户账号',
  SearchPlaceholder: '搜索项目编号/客户名称/用户账号/联系人/电话/联系地址/账单地址',
  businessType: '业务类型',
  businessStatus: '业务状态',
  bandwidth: '订购带宽',
  circuitNumber: '电路编号',
  AccelerateDemand: '加速需求',
  StartingTime: '起租时间',
  LeaseStopTime: '止租时间',
  CustomerDetails: '客户详情',
}
